export default "__VITE_ASSET__a382d453__"